import { Injectable }   from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { PreguntaBase } from '../_models/preguntabase.model';

@Injectable()
export class PreguntasControlService {
  constructor() { }

  toFormGroup(questions: PreguntaBase<any>[] ) {
    let group: any = {};

    questions.forEach(question => {
      group[question.key] = question.required ? new FormControl(question.value || '', Validators.required)
                                              : new FormControl(question.value || '');
    });

    return new FormGroup(group);
  }

}



// WEBPACK FOOTER //
// ./src/app/_services/preguntascontrol.service.ts